import {gql} from '@apollo/client';

export const workspaceMutations = {
    CREATE_WORKSPACE: gql`
        #For Creating Workspace
        mutation CreateWorkspace($input: WorkspaceCreateInput!) {
            createWorkspace(input: $input) {
                id
                name
                description
                workspaceType
                privacyType
                color
                image
            }
        }
    `,

    UPDATE_WORKSPACE: gql`
        #For Updating Workspace
        mutation UpdateWorkspace($input: WorkspaceUpdateInput!) {
            updateWorkspace(input: $input) {
                id
                name
                description
                workspaceType
                privacyType
                color
                image
            }
        }
    `,

    REMOVE_WORKSPACES_BY_IDS: gql`
        #For Removing Workspace
        mutation RemoveWorkspacesByIds($ids: [UUID!]!) {
            removeWorkspacesByIds(ids: $ids) {
                statusCode
                message
                success
                data
            }
        }
    `,
    ADD_USERS_TO_WORKSPACE: gql`
        #For Adding User to Workspace
        mutation AddUsersToWorkspace($request: UserIdsForWorkspaceRequestInput!) {
            addUsersToWorkspace(request: $request) {
                statusCode
                message
                success
                data
            }
        }
    `,
    REMOVE_USERS_FROM_WORKSPACE: gql`
        #For Removing User from Workspace
        mutation RemoveUsersFromWorkspace($request: UserIdsForWorkspaceRequestInput!) {
            removeUsersFromWorkspace(request: $request) {
                statusCode
                message
                success
                data
            }
        }
    `,
    UPDATE_USER_WORKSPACE_TO_BE_SELECTED: gql`
        #For Updating User Workspace to be selected
        mutation UpdateUserWorkspaceToBeSelected($workspaceId: UUID!) {
            updateUserWorkspaceToBeSelected(workspaceId: $workspaceId) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
